<template>
    <b-card class="mb-2" header-tag="header">
        <template #header>
            <h6 class="mb-0 text-center">
                <i class="fa fa-line-chart"></i> Actividad Económica del solicitante
            </h6>
        </template>
        <b-row>
            <b-col md>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label>
                        <b>Empleado</b>
                    </label>
                </div>
            </b-col>
            <b-col md>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label>
                        <b>Independiente</b>
                    </label>
                </div>
            </b-col>
            <b-col md>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label>
                        <b>Pensionado/Jubilado</b>
                    </label>
                </div>
            </b-col>
            <b-col md>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label>
                        <b>Rentista Capital</b>
                    </label>
                </div>
            </b-col>
            <b-col md>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" />
                    <label>
                        <b>Otro</b>
                    </label>
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md="6">
                <div class="form-group">
                    <label for="">Empresa / Negocio </label>
                    <input type="text" class="form-control" placeholder="" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Nit Empresa / Negocio </label>
                    <input type="text" class="form-control" placeholder="" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Teléfono Empresa / Negocio</label>
                    <input type="text" class="form-control" placeholder="" />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Dirección Empresa / Negocio</label>
                    <input type="text" class="form-control" placeholder="" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Ciudad y Depto. Empresa / Negocio</label>
                    <input type="text" class="form-control" placeholder="" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Correo Empresa / Negocio</label>
                    <input type="text" class="form-control" placeholder="" />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Actividad Económica Empresa / Negocio</label>
                    <select class="form-control">
                        <option value="">Comercial</option>
                        <option value="">Industrial</option>
                        <option value="">Transporte</option>
                        <option value="">Construcción</option>
                        <option value="">Agroindustrial</option>
                        <option value="">Servicios</option>
                        <option value="">Financiero</option>
                        <option value="">Público</option>
                        <option value="">Otro</option>
                    </select>
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Código CIIU</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col>
                <h6><b>Si es empleado</b></h6>
                <hr />
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Cargo Actual</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Tiempo en Cargo</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Fecha de Ingreso</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Tipo de Contrato</label>
                    <select class="form-control">
                        <option value="">Fijo</option>
                        <option value="">Indefinido</option>
                        <option value="">Prestación de servicios</option>
                        <option value="">Obra Labor</option>
                        <option value="">Otro</option>
                    </select>
                </div>
            </b-col>
            <div class="w-100"></div>
            <b-col>
                <h6><b>Si es Pensionado/Jubilado</b></h6>
                <hr />
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Empresa Pagadora (Fondo de Pensiones)</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
             <div class="w-100"></div>
            <b-col>
                <h6><b>Si es Independiente</b></h6>
                <hr />
            </b-col>
            <div class="w-100"></div>
            <b-col md>
                <div class="form-group">
                    <label for="">Fecha Camara y Comercio</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
             <b-col md>
                <div class="form-group">
                    <label for="">Codigo CIIU</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Tiempo en Actividad</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
            <b-col md>
                <div class="form-group">
                    <label for="">Nro. Empleados</label>
                    <input type="text" class="form-control" />
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
